import { convertLanguageToISOCode } from "@/lib/language-to-iso-code"
import { AutoTranslatedAgentMessageContent } from "@/modules/chats/components/chat-message/agent-content/auto-translated-agent-message-content"
import { NonAutoTranslatedAgentMessageContent } from "@/modules/chats/components/chat-message/agent-content/non-auto-translated-agent-message-content"
import { OriginalAndAutoTranslatedAgentMessageContent } from "@/modules/chats/components/chat-message/agent-content/original-and-auto-translated-agent-message-content"
import { hasAiGeneratedContent } from "@/modules/chats/lib/has-ai-generated-content"
import { LiveTranslationView, SofiaChatMessage } from "@/modules/chats/types/chat-message"

interface AgentMessageContentRouterProps {
  message: SofiaChatMessage
  liveTranslation: LiveTranslationView
}

export const AgentMessageContentRouter = (props: AgentMessageContentRouterProps) => {
  const { message, liveTranslation } = props

  const messageContent = message.content
  const originalMessageContent = message.metadata?.originalContent ?? ""
  const autoTranslationOriginalContent = message.metadata?.autoTranslationOriginalContent ?? ""
  const translatedContent = message.metadata?.autoTranslationTranslatedContent ?? ""
  const backTranslatedContent = message.metadata?.autoTranslationBackTranslatedContent ?? ""
  const autoTranslationTargetLanguage = message.metadata?.autoTranslationTargetLanguage
  const hasAiGeneratedMessageContent = hasAiGeneratedContent(message.metadata?.aiFeatures)

  const showTripleLanguage = liveTranslation.isLiveTranslationEnabled && Boolean(autoTranslationTargetLanguage)
  const patientLanguageCode = autoTranslationTargetLanguage
    ? convertLanguageToISOCode(autoTranslationTargetLanguage)
    : ""

  if (showTripleLanguage && originalMessageContent) {
    return (
      <OriginalAndAutoTranslatedAgentMessageContent
        agentTypedContent={autoTranslationOriginalContent}
        patientFacingTranslation={translatedContent}
        backTranslatedContent={backTranslatedContent}
        originalMessageContent={originalMessageContent}
        hasAiGeneratedContent={hasAiGeneratedMessageContent}
        patientLanguageCode={patientLanguageCode}
      />
    )
  }

  if (showTripleLanguage) {
    return (
      <AutoTranslatedAgentMessageContent
        agentTypedContent={autoTranslationOriginalContent}
        patientFacingTranslation={translatedContent}
        backTranslatedContent={backTranslatedContent}
        patientLanguageCode={patientLanguageCode}
      />
    )
  }

  return (
    <NonAutoTranslatedAgentMessageContent
      deliveredContent={messageContent}
      originalMessageContent={originalMessageContent}
      hasAiGeneratedContent={hasAiGeneratedMessageContent}
    />
  )
}
